import { FC } from "react";
import { ErrorMessage } from "@hookform/error-message";

type Props = {
    errors: any;
    name: string;
};

export const CustomErrors: FC<Props> = (props: Props) => (
    <div>
        <ErrorMessage errors={props.errors} name={props.name} as={<small className="text-danger" />} />
    </div>
);
